import React from 'react';
import { withTranslation } from 'react-i18next';

import { Fade, Box } from '@mui/material';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { ModalContainer, PaperContainer, SectionInfo } from './styles';
import { ButtonClose } from 'components/NewButton/styles';
import { IconInfor } from '../../../src/assets/icons_svg';

function DocumentModal({
    className,
    handleClose,
    maxWidth,
    minWidth,
    open,
    padding,
    shadow,
    text,
    t,
    themeColor,
}) {
    const iconColor = themeColor?.visual?.icons?.color || '#74CCD4'


    return (
        <ModalContainer
            open={open}
            className={className}
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            shadow={shadow}
            maxwidth={maxWidth}
            minwidth={minWidth}
            disableEnforceFocus
        >
            <Fade in={open} unmountOnExit>
                <PaperContainer padding={padding || '28px'} maxwidth={maxWidth || '569px'}>
                    <GridContainer >
                        <GridItem xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                            <IconInfor sx={{ color: iconColor, fontSize: '80px !important', paddingBottom: '10px' }} />
                        </GridItem>
                    </GridContainer>

                    <GridItem xs={12}>
                        <Box display="flex" justifyContent="center" textAlign="center" width="100%">
                            <SectionInfo sx={{ maxWidth: '400px' }}>{text}</SectionInfo>
                        </Box>

                        <Box display="flex" justifyContent="center" mt={3}>
                            <ButtonClose size="sm" variant="contained" onClick={handleClose}>
                                <i className="icon-ico_cancelar" style={{ fontSize: '18px', marginRight: '10px' }} />
                                {t('BUTTON_CLOSE')}
                            </ButtonClose>
                        </Box>
                    </GridItem>
                </PaperContainer>
            </Fade>
        </ModalContainer>
    );
}



export default withTranslation()(DocumentModal);
